const getVwoABTestVariationsEventData = (campaignData) => {
    let eventData = {};
    for (const id in campaignData) {
        eventData[`campaign_${id}`] = campaignData[id];
    }
    return eventData;
};

export { getVwoABTestVariationsEventData };
//# sourceMappingURL=getABTestVariations.js.map
